import { Text } from '@ui/lib/park/ui/text';
import { Box, BoxProps } from 'styled-system/jsx';

export const SleepIndicator = ({ ...props }: BoxProps) => {
  return (
    <Box bg="#691b21" borderRadius="3px" p="1.5px 3px" {...props}>
      <Text
        textStyle="text.xxsmall"
        color="greyWhite.lightGrey1"
        data-cy="SleepIndicator"
      >
        Closed
      </Text>
    </Box>
  );
};